/**
 * QuizProgress Component
 *
 * Displays progress through quiz questions with animated bar.
 * Shows "Question X of Y" with visual progress indicator.
 */

interface QuizProgressProps {
  current: number; // 0-indexed
  total: number;
}

export function QuizProgress({ current, total }: QuizProgressProps) {
  const percentage = total > 0 ? ((current + 1) / total) * 100 : 0;

  return (
    <div className="quiz-progress">
      <div className="quiz-progress-text">
        Question {current + 1} of {total}
      </div>
      <div className="quiz-progress-bar">
        <div
          className="quiz-progress-fill"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
